import { PurchasingOffer, TransactionTypes } from './type';
import { useMemo, useState } from 'react';

export const usePersistentOffer = () => {
  const [purchasingOffer, setPurchasingOffer] = useState<
    PurchasingOffer | null | undefined
  >(null);
  const getTransactionType = () => {
    if (purchasingOffer?.transactionType)
      return purchasingOffer?.transactionType;
    if (purchasingOffer?.paymentId) return TransactionTypes.Payment;
    if (purchasingOffer?.transactionId) return TransactionTypes.Reward;
    //is web coin types
    return `${TransactionTypes.WebCoin}.${purchasingOffer?.alternativePurchaseType}`;
  };

  const isPaymentSuccess = useMemo(() => {
    return !!purchasingOffer?.paymentId || !!purchasingOffer?.transactionId;
  }, [purchasingOffer]);

  return {
    purchasingOffer,
    clearPurchasingOffer: () => setPurchasingOffer(null),
    persistPurchasingOffer: setPurchasingOffer,
    getTransactionType,
    isPaymentSuccess: isPaymentSuccess,
  };
};
export default usePersistentOffer;
